module.exports = __webpack_public_path__ + "img/varilux.1844ca96.jpg";